import { useCallback, useState } from 'react';

import { OneTimeModal } from '@backrs_ui/grow-ui/src/components/OneTimeModal/OneTimeModal';
import {
  useLookupModalQuery,
  useMarkOneTimeModalSeenMutation,
} from '@backrs_ui/grow-ui/src/redux/oneTimeModal/oneTimeModal.api';

import { skipToken } from '@reduxjs/toolkit/query/react';

type PageModalOptions = Readonly<{
  autoOpen?: boolean;
}>;

type PageModal = Readonly<{
  hasModal: boolean;
  isOpen: boolean;
  open: () => void;
  close: () => void;
  modalNode: JSX.Element | null;
}>;

export const usePageModal = (
  pageKey: string | undefined,
  { autoOpen = false }: PageModalOptions = {},
): PageModal => {
  const { data } = useLookupModalQuery(pageKey ? { kind: 'per_page', pageKey } : skipToken);
  const [markSeen] = useMarkOneTimeModalSeenMutation();
  const [manualOpen, setManualOpen] = useState(false);

  const isOpen = autoOpen ? !!(data && !data.seen) : manualOpen;

  const open = useCallback(() => {
    if (data) setManualOpen(true);
  }, [data]);

  const close = useCallback(() => {
    setManualOpen(false);
    if (data && !data.seen) void markSeen(data.modal.id);
  }, [data, markSeen]);

  return {
    hasModal: !!data,
    isOpen,
    open,
    close,
    modalNode: data && isOpen ? <OneTimeModal open modal={data.modal} onClose={close} /> : null,
  };
};
